import { Component, OnInit } from '@angular/core'

import { OAuthService } from 'angular-oauth2-oidc'
import { filter } from 'rxjs'

import { Character } from '@mmocld/data'

import { WsService } from '../api/ws.service'
import { ChatService } from '../chat/chat.service'
import { CharacterService } from '../model/character.service'
import { RoomService } from '../model/room.service'
import { UserService } from '../model/user.service'
import { SimulatorInstance } from './simulator.entity'

@Component({
  selector: 'app-simulator',
  templateUrl: './simulator.component.html',
  styleUrls: ['./simulator.component.scss'],
})
export class SimulatorComponent implements OnInit {
  isLoggedIn = this.oAuthService.hasValidAccessToken()
  checkedOwnCharacters = false

  instancesCount = 10
  instances: SimulatorInstance[] = []
  character?: Character

  constructor(
    private oAuthService: OAuthService,
    private wsService: WsService,
    private characterService: CharacterService,
    private userService: UserService,
    private roomService: RoomService,
    private chatService: ChatService,
  ) {}

  ngOnInit(): void {
    this.oAuthService.events.pipe(filter((e) => e.type === 'token_received')).subscribe(() => {
      this.isLoggedIn = this.oAuthService.hasValidAccessToken()
    })

    this.userService.findAllCharacters('self').subscribe((characters) => {
      this.character = characters.find((c) => c.name === 'simulator')
      this.checkedOwnCharacters = true
    })
  }
  ngOnDestroy() {
    this.instances.forEach((instance) => {
      if (instance.ws) instance.ws.complete()
    })
  }

  createCharacter() {
    this.characterService.create({ name: 'simulator' }).subscribe((character) => {
      this.character = character
    })
  }
  createInstances() {
    const diff = this.instancesCount - this.instances.length
    if (diff > 0) {
      for (let i = 0; i < diff; i++) {
        const instance = new SimulatorInstance()

        this.instances.push(instance)
      }
    }
    if (diff < 0) {
      for (let i = 0; i < Math.abs(diff); i++) {
        const instance = this.instances[0]
        if (instance.ws) instance.ws.complete()
        this.instances.splice(0, 1)
      }
    }
  }
  connect() {
    this.instances.forEach((instance) => {
      if (!this.character || instance.ws) return
      instance.ws = this.wsService.connect(this.character)
      instance.ws.subscribe({
        next: () => {
          instance.messagesReceived++
        },
      })
    })
  }
  joinRoom() {
    this.roomService.getAll().subscribe((rooms) => {
      if (!this.instances[0].ws) return
      this.roomService.join(this.instances[0].ws, { roomId: rooms[0].roomId })
    })
  }
  sendMessage() {
    this.instances.forEach((instance) => {
      if (!instance.ws) return
      this.chatService.sendRoomMessage(instance.ws, { text: 'simulator is simulating' })
    })
  }
}
